// Menus do header que dobram (usuário, online): [data-dobra-toggle="id-do-menu"] abre #id-do-menu.
// Abrir um fecha os outros; clique fora e Esc fecham; [data-fecha] dentro do menu fecha ao clicar.
const $ = window.jQuery;
const Dobra = require('./Dobra');

const Dropdowns = function () {

    const abertos = [];   // { fechar } de cada menu

    const fecharTodos = function (exceto) {
        abertos.forEach(o => { if (o !== exceto) o.fechar(); });
    };

    const ligar = function () {
        const btn = this;
        const menu = document.getElementById(btn.dataset.dobraToggle);
        if (!menu) return;
        Dobra.numerar(menu.parentNode);

        const abrir = v => {
            if ((menu.dataset.dobrada !== 'true') === !!v) return;
            Dobra.alternar(menu, !!v);
            btn.setAttribute('aria-expanded', v ? 'true' : 'false');
        };
        const par = { fechar: () => abrir(false) };
        abertos.push(par);

        $(btn).on('click', () => {
            const abrindo = menu.dataset.dobrada === 'true';
            fecharTodos(par);
            abrir(abrindo);
        });
        // sem stopPropagation: os .bt-ajax do app.js são delegados no document
        $(menu).on('click', e => { if ($(e.target).closest('[data-fecha]').length) abrir(false); });
    };

    return {
        init: function () {
            $('[data-dobra-toggle]').each(ligar);
            $(document).on('click', e => {
                if (!$(e.target).closest('[data-dobra-toggle], .user-menu').length) fecharTodos();
            });
            $(document).on('keydown', e => { if (e.key === 'Escape') fecharTodos(); });
        },
        // A LIA de tela cheia (LiaFs.js) fecha as dobras ao abrir: o .user-menu (z 1060) ficaria acima dela.
        fecharTodos: function () { fecharTodos(); }
    };
}();

module.exports = Dropdowns;
